import { render, staticRenderFns } from "./GoodsGlobalSearch.vue.js?vue&type=template&id=5747e7dc&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./GoodsGlobalSearch.vue?vue&type=template&id=5747e7dc&scoped=true"
import script from "./GoodsGlobalSearch.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./GoodsGlobalSearch.vue?vue&type=script&lang=js"
export * from "./GoodsGlobalSearch.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./GoodsGlobalSearch.vue?vue&type=script&lang=js"
import style0 from "./GoodsGlobalSearch.vue.scss?vue&type=style&index=0&id=5747e7dc&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./GoodsGlobalSearch.vue?vue&type=style&index=0&id=5747e7dc&lang=scss&scoped=true"
import style1 from "./GoodsGlobalSearch.vue.scss?vue&type=style&index=1&id=5747e7dc&lang=scss!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./GoodsGlobalSearch.vue?vue&type=style&index=1&id=5747e7dc&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5747e7dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5747e7dc')) {
      api.createRecord('5747e7dc', component.options)
    } else {
      api.reload('5747e7dc', component.options)
    }
    module.hot.accept("./GoodsGlobalSearch.vue.js?vue&type=template&id=5747e7dc&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./GoodsGlobalSearch.vue?vue&type=template&id=5747e7dc&scoped=true", function () {
      api.rerender('5747e7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/components/GoodsGlobalSearch.vue"
export default component.exports